(() => {
  const initializeQuickAdd = () => {
    if (document.documentElement.dataset.khQuickAddReady === 'true') return;
    document.documentElement.dataset.khQuickAddReady = 'true';

  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');

  const showToast = (message, isError = false) => {
    document.querySelector('.kh-cart-toast')?.remove();
    const toast = document.createElement('div');
    toast.className = `kh-cart-toast${isError ? ' is-error' : ''}`;
    toast.setAttribute('role', isError ? 'alert' : 'status');
    toast.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    toast.setAttribute('aria-atomic', 'true');

    const icon = document.createElement('strong');
    icon.className = 'kh-cart-toast__icon';
    icon.textContent = isError ? '!' : '✓';
    const copy = document.createElement('span');
    copy.textContent = message;
    toast.append(icon, copy);

    if (!isError) {
      const cartLink = document.createElement('a');
      const root = window.Shopify?.routes?.root || '/';
      cartLink.href = `${root}cart`;
      cartLink.textContent = isEnglish ? 'View cart' : 'Warenkorb ansehen';
      toast.appendChild(cartLink);
    }

    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 220);
    }, 4200);
  };

  const updateCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('.kh-cart, .nav__actions a[href*="/cart"]').forEach((element) => {
      element.textContent = cart.item_count;
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();
    event.stopPropagation();
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const originalLabel = button.textContent;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Cart request failed');
      await updateCartCount();
      button.textContent = '✓';
      button.classList.add('is-added');
      showToast(isEnglish ? '1 bottle added to your cart.' : '1 Flasche wurde zum Warenkorb hinzugefügt.');
      window.setTimeout(() => {
        button.textContent = originalLabel;
        button.classList.remove('is-added');
      }, 1800);
    } catch (error) {
      showToast(isEnglish ? 'The product could not be added.' : 'Das Produkt konnte nicht hinzugefügt werden.', true);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuickAdd, { once: true });
  } else {
    initializeQuickAdd();
  }
})();
